import type { Map as MapboxMap } from 'mapbox-gl';
import { LayerId } from '@/features/locations/constants';

/**
 * Resolves the hunting zone (if any) under a map coordinate via Mapbox's own
 * hit-test against the zones-fill layer — the same mechanism
 * `useZoneInteractions` uses for zone-click selection, reused here purely for
 * Mixpanel attribution (no selection/navigation side effect). Returns null
 * when the zones layer isn't currently on the map (overlay off) or nothing is
 * underneath the point.
 */
export function zoneIdAtLngLat(
  map: MapboxMap,
  lngLat: { lng: number; lat: number },
): string | null {
  if (!map.getLayer(LayerId.ZONES_FILL)) return null;
  const point = map.project(lngLat);
  const feature = map.queryRenderedFeatures(point, { layers: [LayerId.ZONES_FILL] }).at(0);
  const id = feature?.properties?.id;
  return typeof id === 'string' ? id : null;
}
